import { useTranslation } from 'react-i18next';
import { Box, Typography, EmptyState } from '@glplus/glpweb-dsl';
import type { IconName } from '@glplus/glpweb-dsl';

/**
 * A §15z section whose build has not landed yet. The side nav carries the
 * FINISHED IA from day one (plan against the finished list); each section's
 * screens arrive with its phase (`docs/vendor/vendor-build-plan-2026-09-13.md`).
 * Sections outside the numbered phases (Reports & analytics, Food recalls) pass
 * no phase and get the unscheduled line.
 */
export default function ComingSoon({ sectionKey, phase, icon }: { sectionKey: string; phase?: number; icon: IconName }) {
  const { t } = useTranslation();
  return (
    <Box sx={{ maxWidth: 720 }}>
      <Typography component="h1" sx={{ fontSize: 32, fontWeight: 700, color: '#303A42', mb: 2 }}>
        {t(`nav.${sectionKey}`)}
      </Typography>
      <EmptyState
        icon={icon}
        title={t('comingSoon.title')}
        body={phase ? t('comingSoon.body', { phase }) : t('comingSoon.bodyUnscheduled')}
        alignment="start"
        backgroundColor="#fff"
        border="1px solid #E5E5E5"
        borderRadius={10}
        iconColor="#A85200"
      />
    </Box>
  );
}
